const DEFAULT_READY_APP_DOMAIN_SUFFIX = 'app.risman.pro';

export const READY_APP_DOMAIN_SUFFIX = String(
  process.env.REACT_APP_READY_APP_DOMAIN_SUFFIX || DEFAULT_READY_APP_DOMAIN_SUFFIX
)
  .trim()
  .replace(/^\.+/, '')
  .replace(/\.+$/, '') || DEFAULT_READY_APP_DOMAIN_SUFFIX;

export const buildReadyAppFqdn = (subdomain, suffix = READY_APP_DOMAIN_SUFFIX) => {
  const label = String(subdomain || '').trim().toLowerCase();
  if (!label) {
    return '';
  }
  return `${label}.${suffix}`;
};
